import React, { useRef, useContext, useState } from "react";

import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Grid,
  TextField,
} from "@material-ui/core";

import Btn from "../../components/buttons/Btn";
import { CustomSpan } from "./styles";
import { authenticateUserWithPermissions } from "../../repositories/qerpapi/erp/acesso/v1/UsuarioRepository";
import { notify } from "../../utils/notify";
import { QueryParamsContext } from "../../context/QueryParamsContext";
import Loading from "../basics/Loading";

const ModalAutenticarUsuario = ({
  modalAuthenticateOpen,
  setModalAuthenticateOpen,
  warnings = [],
  // O callback sempre vai ter um parâmetro que é o ID de usuário,
  // no caso, o que tentaram logar, e conseguiram.
  callback = () => {},
}) => {
  const { queryParams } = useContext(QueryParamsContext);
  const emailRef = useRef(null);
  const passwordRef = useRef(null);
  const [authenticateError, setAuthenticateError] = useState("");
  const [loadingState, setLoadingState] = useState(false);

  const handleClose = () => {
    setModalAuthenticateOpen(false);
  };

  const handleSendData = async () => {
    let emailValue = emailRef.current?.value;
    let passwordValue = passwordRef.current?.value;

    try {
      setLoadingState(true);
      const request = await authenticateUserWithPermissions({
        empresa_cnpj: queryParams.empresa_cnpj,
        body: {
          params: Buffer.from(
            JSON.stringify({
              email: emailValue,
              password: passwordValue,
              neededPermissions: warnings.map((e) => e.key),
            })
          ).toString("base64"),
        },
      });

      if (request.success) {
        if (!request.data?.idUsuario)
          return notify("ID de usuário não encontrado.");

        callback(request.data?.idUsuario);
        handleClose();
      } else {
        setAuthenticateError(request.message);
        if (request.data?.notFounded) {
          let arrayMessages = [];
          (request.data?.notFounded || []).forEach((permission) => {
            arrayMessages.push(warnings.find((e) => e.key === permission));
          });

          arrayMessages.forEach((message) => {
            notify(`Permissão não encontrada: ${message.message}`);
          });
          return;
        }

        return notify("Ocorreu um erro ao autenticar o usuário.");
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoadingState(false);
    }
  };

  return (
    <Dialog open={modalAuthenticateOpen} fullWidth maxWidth="xs">
      <Loading open={loadingState} />
      <DialogTitle
        id="customized-dialog-title"
        onClose={handleClose}
        children="Autenticação do usuário"
      />
      <DialogContent>
        <Grid
          container
          spacing={2}
          style={{ flexDirection: "column", marginBottom: "25px" }}
        >
          {warnings.map((warning, i) => (
            <Grid item xs={12} sm={12} lg={12} key={i}>
              <CustomSpan>- {warning.message}</CustomSpan>
            </Grid>
          ))}
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} lg={12}>
            <TextField
              label="E-mail"
              fullWidth
              type="email"
              inputProps={{
                ref: emailRef,
              }}
              error={!!authenticateError}
              helperText={authenticateError || ""}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} lg={12}>
            <TextField
              label="Senha"
              fullWidth
              type="password"
              inputProps={{
                ref: passwordRef,
              }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Btn
          autoFocus
          onClick={handleClose}
          bgcolor="grey"
          hovercolor="blue"
          label="Cancelar"
        />
        <Btn
          autoFocus
          onClick={handleSendData}
          bgcolor="primary"
          hovercolor="orange"
          label="Liberar venda"
        />
      </DialogActions>
    </Dialog>
  );
};

export default ModalAutenticarUsuario;
